import {Injectable} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {map} from 'rxjs/operators';
import {mensajesModalRnec} from 'src/app/core/enums/rnec/mensaje-modal-rnec.enum';
import {IVI, IVI_MESSAGES_USUARIO} from 'src/app/core/enums/rnec/rnec.enum';
import {DocumentosDigitalesManager} from 'src/app/core/gestor-contenido-documentos/validarDocumento';
import {IDocumentoNoExigible} from 'src/app/core/models/documentosObligatorios/idocumentosObligatorios';
import {GeneralResponse} from 'src/app/core/models/general-response/general-response';
import {DetalleAfiliadoHijo} from 'src/app/core/models/rnec/detalleAfiliadoHijo';
import {IdentidadPersonaDto} from 'src/app/core/models/rnec/identidad-persona.dto';
import {RnecResponseDto} from 'src/app/core/models/rnec/rnec-response.dto';
import {ModalVariadoService} from 'src/app/core/services/modal-variado/modal-variado.service';
import {ObligatoriedadDocumentosService} from 'src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service';
import {RnecService} from 'src/app/core/services/rnec/rnec.service';
import {ValidacionesFormularioService} from './validacionesFormulario.service';
import {CambioEstadoCivilEnumMap} from '../../../../../core/enums/cambio-estado-civil-enum';


@Injectable({
  providedIn: 'root'
})
export class ConsultaRnecService {
  private contIntento = 0;
  private intentosPermitidos = 2;
  private estadoRnec: any;
  public botonContinuar: boolean = false;
  private tipoPersonaAnterior: string = '';

  constructor(
    private validacionesFormularioService: ValidacionesFormularioService,
    private _ModalVariadoService: ModalVariadoService,
    private _RnecService: RnecService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public _ObligatoriedadDocumentosService: ObligatoriedadDocumentosService
  ) {
  }

  public realizarConsulta(
    tipoPersona: string,
    identidadBeneficiario: any,
    personaControl: any,
    form: any,
    index?: number,
  ): void {
    this.contIntento = tipoPersona !== this.tipoPersonaAnterior ? 0 : this.contIntento;

    const acciones = {
      documentoInvalido: () => this.mostrarError(tipoPersona, personaControl, form),
      ejecutarValidacion: () => {
        this.ejecutarValidacion(tipoPersona, identidadBeneficiario, personaControl, form);
        this.contIntento++;
      },
      maxIntentos: () => {
        this.mostrarError(tipoPersona, personaControl, form);
        this.contIntento = 0;
      }
    };
    if (this.esDocumentoValido(personaControl)) {
      if (this.contIntento < this.intentosPermitidos) {
        acciones.ejecutarValidacion();
      } else {
        acciones.maxIntentos();
      }
    } else {
      acciones.documentoInvalido();
    }
    this.tipoPersonaAnterior = tipoPersona;
  }

  private ejecutarValidacion(tipoPersona: string, identidadBeneficiario: any, personaControl: any, form: any, motivoRetro?: any): void {
    const estadoCivilCodigo = personaControl.controls['estadoCivil']?.value?.codigo;
    const estadosValidos = [
      CambioEstadoCivilEnumMap.MARRIED.toString(),
      CambioEstadoCivilEnumMap.SEPARATED.toString(),
      CambioEstadoCivilEnumMap.WIDOWER.toString()
    ];
    if (estadoCivilCodigo != null && estadosValidos.includes(estadoCivilCodigo)) {
      this._ObligatoriedadDocumentosService.documentosConyugeListosSubject.next(true);
      return;
    }
    const estrategiaValidacion: Record<string, () => void> = {
      beneficiario: () => this.validarBeneficiario(personaControl, identidadBeneficiario, form),
      default: () => this.consultaRnec(tipoPersona, identidadBeneficiario, personaControl),
    };

    (estrategiaValidacion[tipoPersona] || estrategiaValidacion.default)();
  }


  async validarBeneficiario(personaControl: any, identidadBeneficiario: any, form: any): Promise<void> {
    const result = await this.consultaRnec('beneficiario', identidadBeneficiario, personaControl);
    const trabajadorValues = form;
    const detalleAfiliadoHijo: DetalleAfiliadoHijo = {
      identidadPersonaHijo: IdentidadPersonaDto.objBeneficiarioARnc(personaControl.getRawValue()),
      identidadPersonaAfiliado: IdentidadPersonaDto.objTrabajadorARnc(trabajadorValues)
    };
    const validacionExitosa = result.soporteDigital !== '';
    const falloMaximo = this.contIntento >= this.intentosPermitidos;
    let resultHijo: any = null;
    if (validacionExitosa) {
      resultHijo = await this.validarHijo(detalleAfiliadoHijo, personaControl);
    }
    if (falloMaximo || (resultHijo && resultHijo.soporteParentesco !== '') || (resultHijo && resultHijo.soporteParentesco === '')) {
      this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true);
    }
  }

  private mostrarError(tipoPersona: string, personaControl: any, form: any): void {
    const handlers: Record<string, (control: any, tipo: string, form: FormGroup) => void> = {
      trabajador: this.mostrarErrorTitular.bind(this),
      conyuge: this.mostrarErrorConyuge.bind(this),
      beneficiario: this.mostrarErrorBeneficiario.bind(this)
    };

    handlers[tipoPersona]?.(personaControl, tipoPersona, form);
  }

  private mostrarErrorTitular(personaControl: any, tipoPersona: any): void {
    try {
      this.validacionesFormularioService.validarTrabajador(personaControl);
      this.validarDocumentos(personaControl, tipoPersona);
      this._ModalVariadoService.modalError(mensajesModalRnec.datosParaDoc);
      this.botonContinuar = true;
      personaControl.get('EsValido').setValue(false);
    } catch (error) {
      console.error('Error en mostrarErrorTitular:', error);
    }
  }

  private mostrarErrorConyuge(personaControl: any, tipoPersona: any): void {
    this.validacionesFormularioService.validarConyuge(personaControl);
    this.validarDocumentos(personaControl, tipoPersona);
    this._ModalVariadoService.modalError(mensajesModalRnec.datosParaDoc);
    this._ObligatoriedadDocumentosService.documentosConyugeListosSubject.next(true);

    const btnConsultarConyuge = document.getElementById('btnConsultarConyuge');
    if (btnConsultarConyuge) {
      btnConsultarConyuge.style.display = 'none';
    } else {
      console.log('El botón con id "btnConsultarConyuge" no se encontró.');
    }
  }


  private mostrarErrorBeneficiario(personaControl: any, tipoPersona: any, form: any): void {
    this.validacionesFormularioService.validarParentescoBeneficiario(personaControl);
    this.validarDocumentos(personaControl, tipoPersona, form);
    this._ModalVariadoService.modalError(mensajesModalRnec.datosParaDoc);
    personaControl.get('EsValido').setValue(true);
  }


  async consultaRnec(tipoPersona: string, identidadBeneficiario: any, form: FormGroup): Promise<RnecResponseDto> {
    this._ModalVariadoService.ModalProceso('Procesando...');
    return new Promise((resolve, reject) => {
      this._RnecService.consultar(identidadBeneficiario).subscribe(
        (rnecResponse: GeneralResponse<RnecResponseDto>) => {
          this.estadoRnec = rnecResponse.body;
          if (!this._RnecService.esIdentidadValidadaExitosamente(this.estadoRnec.ivi)) {
            setTimeout(() => this.finalizarProceso(), 100);
            return resolve(this.estadoRnec);
          }
          this.handlePersonaValidation(tipoPersona, form);
          const acciones: Record<string, () => void> = {
            trabajador: () => {
              form.patchValue({base64Valid: this.estadoRnec.soporteDigital});
            },
            conyuge: () => this.actualizarGrupoConyugeBase64(form),
            beneficiario: () => this.actualizarGrupoBeneficiarioBase64(form)
          };
          acciones[tipoPersona]?.();

          setTimeout(() => this.finalizarProceso(), 100);
          resolve(this.estadoRnec);
        },
        (error) => reject(error)
      );
    });
  }

  async validarHijo(detalleAfiliadoHijo: DetalleAfiliadoHijo, form: FormGroup): Promise<RnecResponseDto> {
    return new Promise((resolve, reject) => {
      this._RnecService.validarHijo(detalleAfiliadoHijo).subscribe(
        (response: GeneralResponse<RnecResponseDto>) => {
          this.estadoRnec = response.body;
          if (response.body.validacion && response.body.soporteParentesco !== '') {
            this.realizarAccionesValidacionExitosa(form);
          } else {
            this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true)
            this._ModalVariadoService.modalAlerta(mensajesModalRnec.errorParentesco);
          }
          resolve(this.estadoRnec);
        },
        (error) => reject(error)
      );
    });
  }

  private realizarAccionesValidacionExitosa(form: FormGroup): void {
    this.handlePersonaValidation('beneficiario', form);
    this.procesarValidacionHijoExitosa(form);
  }

  private finalizarProcesoConRetraso(): void {
    setTimeout(() => this.finalizarProceso(), 100);
  }

  private handlePersonaValidation(tipoPersona: string, form: FormGroup) {
    const validadores = {
      trabajador: () => this.validacionesFormularioService.validarTrabajador(form),
      conyuge: () => this.validacionesFormularioService.validarConyuge(form),
      beneficiario: () => this.validacionesFormularioService.validarParentescoBeneficiario(form)
    };
    validadores[tipoPersona]();
  }

  private actualizarGrupoConyugeBase64(form: FormGroup) {
    document.getElementById('btnConsultarConyuge')?.style.setProperty('display', 'none');

    const conyugeGroup = form.get('conyuge') as FormGroup;

    if (conyugeGroup) {
      if (!conyugeGroup.contains('base64Valid') && form.contains('base64Valid')) {
        conyugeGroup.addControl('base64Valid', form.get('base64Valid')!);
      }
      conyugeGroup.get('base64Valid')?.setValue(this.estadoRnec?.validacion);
    } else {
      form.patchValue({
        base64Valid: this.estadoRnec?.validacion,
      });
    }

    this.validarDocumentos(form, 'conyuge');

    const documentosActualizados = this._ObligatoriedadDocumentosService.documentosConyuge.filter(
      documento =>
        documento.idForm !== 'documentoIdentidadConyuge' &&
        documento.idForm !== 'documentoDeIdentidad'
    );

    this._ObligatoriedadDocumentosService.documentosConyuge = documentosActualizados;
    this._ObligatoriedadDocumentosService.documentosConyugeSubject.next(documentosActualizados);
    this._ObligatoriedadDocumentosService.documentosConyugeListosSubject.next(documentosActualizados.length > 0);
  }


  private actualizarGrupoBeneficiarioBase64(form: FormGroup) {
    form.get('EsValido').setValue(true);
    if (!form.contains('base64Valid')) {
      form.addControl('base64Valid', new FormControl(null));
    }

    form.patchValue({base64Valid: this.estadoRnec.soporteDigital});

    this.validacionesFormularioService.validarParentescoBeneficiario(form);
    const documentosActualizados = this._ObligatoriedadDocumentosService.documentosBeneficiario.filter(documento =>
      documento.idForm !== 'idBeneficiario'
    );
    this._ObligatoriedadDocumentosService.documentosBeneficiario = documentosActualizados;
    this._ObligatoriedadDocumentosService.documentosBeneficiarioSubject.next(documentosActualizados);
  }

  private procesarValidacionHijoExitosa(form: FormGroup): void {
    form.get('EsValido')?.setValue(true);

    if (!form.contains('base64ValidHijo')) {
      form.addControl('base64ValidHijo', new FormControl(null));
      form.addControl('base64Valid', new FormControl(null));
    }

    form.patchValue({base64ValidHijo: this.estadoRnec.soporteParentesco});
    form.patchValue({base64Valid: this.estadoRnec.soporteParentesco});
    const documentosActualizados = this._ObligatoriedadDocumentosService.documentosBeneficiario.filter(documento =>
      documento.idForm !== 'docIdeTrabajador' &&
      documento.idForm !== 'regBeneficiario'
    );

    this._ObligatoriedadDocumentosService.documentosBeneficiario = documentosActualizados;
    this._ObligatoriedadDocumentosService.documentosBeneficiarioSubject.next(documentosActualizados);
  }

  public async validarDocumentos(personaControl: any, tipoPersona: any, form?: FormGroup): Promise<void> {
    const beneficiario = personaControl.getRawValue();
    const trabajadorValues = form;
    this.configurarDocumentosPorTipoPersona(tipoPersona);
  }

  private configurarDocumentosPorTipoPersona(tipoPersona: string): void {
    const documentosMap: { [key: string]: any } = {
      'beneficiario': this._ObligatoriedadDocumentosService.documentosBeneficiario,
      'trabajador': this._ObligatoriedadDocumentosService.documentosTitular,
      'conyuge': this._ObligatoriedadDocumentosService.documentosConyuge
    };

    const documentos = documentosMap[tipoPersona];

    if (documentos) {
      DocumentosDigitalesManager.setDocumentosSolicitud(documentos);
    }
  }

  private obtenerDocumentosExistentes(trabajadorValues: any, beneficiario: any, tipoPersona: string) {
    this._ObligatoriedadDocumentosService
      .getDocumentosDigitalesExistentesDepropietario(
        trabajadorValues.NumIdTrabajador,
        beneficiario.numeroDocumento
      )
      .pipe(map((response: GeneralResponse<IDocumentoNoExigible[]>) => response))
      .subscribe((response: GeneralResponse<IDocumentoNoExigible[]>) => {
        this.procesarRespuestaDeDocumentos(response.body, trabajadorValues, beneficiario, tipoPersona);
      });
  }

  private procesarRespuestaDeDocumentos(
    responseBody: IDocumentoNoExigible[],
    trabajadorValues: any,
    beneficiario: any,
    tipoPersona: string
  ) {
    const {documentosObligatorios, documentosEliminados} = DocumentosDigitalesManager.retirarDocumentosNoExigibles(
      responseBody,
      trabajadorValues.TipoIdTrabajador,
      trabajadorValues.NumIdTrabajador,
      beneficiario.TipoIdConyuge,
      beneficiario.NumIdConyuge
    );

    const todosLosDocumentos = [...documentosObligatorios, ...documentosEliminados];

    this.actualizarDataJsonConDocumentos(todosLosDocumentos, tipoPersona);
  }

  private actualizarDataJsonConDocumentos(documentosObligatorios: IDocumentoNoExigible[], tipoPersona: string) {
    if (tipoPersona == 'beneficiario') {
      this._ObligatoriedadDocumentosService.documentosBeneficiario = documentosObligatorios;
      this._ObligatoriedadDocumentosService.documentosBeneficiarioSubject.next(this._ObligatoriedadDocumentosService.documentosBeneficiario);
      this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true);
    }

    if (tipoPersona == 'trabajador') {
      this._ObligatoriedadDocumentosService.documentosTitular = documentosObligatorios;
    } else {
      this._ObligatoriedadDocumentosService.documentosConyuge = documentosObligatorios;
      this._ObligatoriedadDocumentosService.documentosConyugeListosSubject.next(true);
    }
  }

  public modalOpen(): void {
    const modalMap: { [key: string]: Function } = {
      [IVI.IVE]: () => {
        this._ModalVariadoService.modalConfirmacion(IVI_MESSAGES_USUARIO[this.estadoRnec.ivi]);
      },
      default: () => {
        this._ModalVariadoService.modalError(IVI_MESSAGES_USUARIO[this.estadoRnec.ivi]);
      }
    };

    (modalMap[this.estadoRnec.ivi] || modalMap.default)();
  }

  public finalizarProceso() {
    this.dialog.closeAll();
    this.modalOpen();
  }

  private esDocumentoValido(tipoIdentificacion: FormGroup): boolean {
    const valores = tipoIdentificacion.getRawValue();
    let tipoDocumento = '';
    if (valores?.conyuge) {
      tipoDocumento = valores?.conyuge?.TipoIdConyuge;
    } else {
      tipoDocumento = valores?.TipoIdConyuge || valores?.TipoIdTrabajador || valores?.tipoDocumento;
    }
    return this._RnecService.esTipoDocumentoParaConsultar(tipoDocumento);
  }
}
